import * as React from 'react'
function SvgShieldTimeline(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32.33 6.028l-12-2a2.03 2.03 0 00-.66 0l-12 2A2 2 0 006 8v14c0 7.732 6.268 14 14 14s14-6.268 14-14V8a2 2 0 00-1.67-1.972zm-19.143 19.33l4.313-4.322 2.5 2.5a2 2 0 002.91-.085l6.167-6.937a2 2 0 00.272-2.265l-.054-.103a1.046 1.046 0 00-1.706-.205L21.5 20.786 18.914 18.2a1.998 1.998 0 00-2.827.001l-5.025 5.032a1.504 1.504 0 002.125 2.125z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgShieldTimeline
